// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var ApiConfigurationsList$ReactHooksTemplate = require("./apiConfigurationsList.res.js");

function SmsChannel(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: "SMS",
                      className: "px-5 py-6 border-b border-gray-300 text-darkcharcoal font-bold text-xl"
                    }),
                JsxRuntime.jsx(ApiConfigurationsList$ReactHooksTemplate.make, {
                      apiType: "SMS"
                    })
              ]
            });
}

var make = SmsChannel;

exports.make = make;
/* react/jsx-runtime Not a pure module */
